import React from "react";
import { Box, Container, Typography } from "@mui/material";
import SurveyForm from "./SurveyForm";

const SurveySection = () => {
  return (
    <Box
      sx={{
        background: "linear-gradient(180deg, #FAF5E9 0%, #F5EED8 100%)",
        py: { xs: 6, md: 10 },
        borderTop: "1px solid #EAE2D1",
        borderBottom: "1px solid #EAE2D1",
        overflowX: "hidden",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "300px 1fr" },
            columnGap: { md: 8 },
            rowGap: { xs: 3, md: 0 },
            alignItems: "start",
          }}
        >
          {/* ── Left: Heading ─────────────────────────────────── */}
          <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
            <Typography
              sx={{
                color: "#B8892B",
                fontWeight: 700,
                letterSpacing: "0.2em",
                fontSize: "0.85rem",
                textTransform: "uppercase",
                mb: 2,
              }}
            >
              District 8 · Voter Outreach
            </Typography>

            <Typography
              sx={{
                fontFamily: "'Playfair Display', serif",
                color: "#072844",
                fontWeight: 700,
                lineHeight: 1.15,
                mb: 3,
                fontSize: { xs: "1.6rem", sm: "2rem", md: "2.6rem" },
              }}
            >
              Help shape how we{" "}
              <Box
                component="span"
                sx={{
                  color: "#B8892B",
                  fontStyle: "italic",
                  fontWeight: 600,
                }}
              >
                reach you
              </Box>
            </Typography>

            <Typography
              sx={{
                color: "#5b5648",
                fontSize: { xs: "0.85rem", md: "1rem" },
                lineHeight: 1.7,
                mx: { xs: "auto", md: 0 },
                maxWidth: 480,
              }}
            >
              A quick 1-minute survey. Your answers directly shape how we
              knock on doors, make calls, and share information with District
              8 neighbors this fall.
            </Typography>
          </Box>

          {/* ── Right: Form ───────────────────────────────────── */}
          <Box sx={{ minWidth: 0, overflow: "hidden" }}>
            <SurveyForm />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default SurveySection;
